import { baseBUCGet } from '../base/baseBUC';

const str = '';

export const buildingDocumentModelGet = ({ buildingId = '', userId = '' }) => {
    return {
        description: str,
        files: [],
        title: str,
        ...baseBUCGet({ userId: userId, buildingId: buildingId, }),
    }
};